import React, { useState, useCallback, ReactElement, ReactNode } from 'react';
import { Container, MenuButton, MenuAppBarItem, CenterContent } from './styles';
import { MenuIcon } from 'ui-components/src/components/atoms/icons/MenuIcon';
import { BaseDrawer } from './components/BaseDrawer';
import { NavigationDrawer } from '../NavigationDrawer';

// Explicitly include children in props
export interface AppBarProps {
  children?: ReactNode;
  rightDrawers?: {
    key: string;
    triggerIcon: ReactElement;
    drawer: ReactElement;
  }[];
  notificationCount?: number | string;
}

export const AppBar: React.FC<AppBarProps> = ({ children, rightDrawers }) => {
  const [isLeftDrawerOpen, setIsLeftDrawerOpen] = useState<boolean>(false);
  const [activeRightDrawer, setActiveRightDrawer] = useState<string>();

  const toggleLeftDrawer = useCallback(() => {
    setIsLeftDrawerOpen(!isLeftDrawerOpen);
  }, [isLeftDrawerOpen]);

  const toggleRightDrawer = useCallback(
    (key: string) => {
      if (activeRightDrawer !== key) {
        setActiveRightDrawer(key);
      } else {
        setActiveRightDrawer('');
      }
    },
    [activeRightDrawer],
  );

  return (
    <Container>
      <>
        <MenuAppBarItem $borderRight>
          <MenuButton onClick={toggleLeftDrawer}>
            <MenuIcon />
          </MenuButton>
        </MenuAppBarItem>
        <BaseDrawer
          isOpen={isLeftDrawerOpen}
          toggle={toggleLeftDrawer}
          drawer={<NavigationDrawer />}
          anchor="left"
        />
      </>
      {children}
      <CenterContent />
      {rightDrawers?.map((drawerConfig) => (
        <React.Fragment key={drawerConfig.key}>
          <MenuAppBarItem $borderLeft align="right">
            <MenuButton onClick={() => toggleRightDrawer(drawerConfig.key)}>
              {drawerConfig.triggerIcon}
            </MenuButton>
          </MenuAppBarItem>
          <BaseDrawer
            isOpen={activeRightDrawer === drawerConfig.key}
            toggle={() => toggleRightDrawer(drawerConfig.key)}
            drawer={drawerConfig.drawer}
            anchor="right"
          />
        </React.Fragment>
      ))}
    </Container>
  );
};
